import { useUpdateEffect } from 'ahooks';
import navigationLocker from '../../../../classes/navigationLocker';
// import { useFocus } from 'src/hooks';
import { useAppSelector } from '../../../../hooks/hooks';
import store from '../../../../store';
import { setFieldEventSubmitForm } from '../../../../store/fieldEventsSlice';
import fieldsStore from '../fieldsStore/fieldsStore';
import { EXECUTION_FORM } from '../FormsController';
import { ApiaUtil } from '@apia/components';

function newFormValue(name: string, value: string) {
  const element = document.createElement('input');
  element.type = 'hidden';
  element.name = name;
  element.value = value;
  return element;
}

const ServerSubmitForm = () => {
  const formSubmitAction = useAppSelector(
    (state) => state.fieldEventsSlice.formSubmitAction,
  );
  let { actionGoto } = useAppSelector((state) => state.appStateSlice);
  const values = useAppSelector(
    (global) =>
      global.previousValidationSlice.forms[EXECUTION_FORM]?.submitValues,
  );
  useUpdateEffect(() => {
    void (async function synchronizeAndSubmitForm() {
      // sessionstore docuemnt.activeElement
      if (!actionGoto?.match(/action=getTask/)) {
        const hasSynchronized = await fieldsStore.synchronize();
        if (!hasSynchronized) {
          store.dispatch(setFieldEventSubmitForm(null));
          return;
        }
      }
      const form = document.createElement('form');
      form.method = 'post';
      document.body.appendChild(form);
      let urlAppend = `&react=true`;
      if (window.IS_EDIT_GRID_MODAL) urlAppend += '&editionMode=true';

      form.action = formSubmitAction + urlAppend;

      if (values)
        Object.entries(values).forEach(([name, value]) => {
          form.append(newFormValue(name, value as string));
        });

      const currentTab = ApiaUtil.instance.tabs.currentTab;

      if (formSubmitAction !== null) {
        // submit field event via POST
        if (document.activeElement?.id) {
          sessionStorage.setItem('fieldID', document.activeElement?.id);
        }
        Object.assign(currentTab?.state ?? {}, { originalUrl: form.action });

        navigationLocker.unlock();
        form.submit();
        form.remove();
      }
      if (actionGoto !== null) {
        // navigate via buttons
        if (!actionGoto.startsWith('/')) actionGoto = `/${actionGoto}`;
        form.action =
          (actionGoto.startsWith(`${window.CONTEXT}/`) ? '' : window.CONTEXT) +
          actionGoto +
          urlAppend;
        Object.assign(currentTab?.state ?? {}, { originalUrl: form.action });

        navigationLocker.unlock();
        form.submit();
        form.remove();
      }
    })();
  }, [actionGoto, formSubmitAction]);

  return null;
};

export default ServerSubmitForm;
